import React, { useState, Suspense } from "react";

export default function PDFReaderCM({ fileUrl }) {
 
    return (
    <iframe
      src={fileUrl}
      title="PDF Viewer"
      style={{
        width: "100%",
        height: "90vh",
        border: "none",
        borderRadius: "8px",
      }}
    />
  );
}
